import faker from 'faker';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { formatDistance } from 'date-fns';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
// material
import {
  Box,
  Stack,
  Link,
  Card,
  Button,
  Divider,
  Typography,
  CardHeader,
  colors
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// utils
import { mockImgCover } from '../../../utils/mockImages';
//
import Scrollbar from '../../Scrollbar';

// ----------------------------------------------------------------------

RequestsPackage.propTypes = {
  item: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  selectedPackage: PropTypes.object.isRequired
};

export default function RequestsPackage({ selectedPackage, item, handleClick }) {
  const theme = useTheme();
  return (
    <Card sx={{ maxWidth: 250 }}>
      <CardHeader
        title={item?.attributes?.name}
        style={
          selectedPackage.id === item.id
            ? { color: theme.palette.primary.main }
            : { color: '#424242' }
        }
      />

      <Box>
        <Stack direction="column" spacing={1} sx={{ p: 3, pr: 0, minHeight: 170 }}>
          {item?.meta?.ui_informations?.map((information) => (
            <Typography variant="body2" style={{ padding: 3 }}>
              {information?.content}
            </Typography>
          ))}
        </Stack>
      </Box>

      <Divider p={2} />

      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          bgcolor: selectedPackage.id === item.id ? 'primary.main' : 'background.neutral'
        }}
      >
        <Button
          disabled={item.status === 'inactive'}
          size="small"
          color="inherit"
          sx={{ color: selectedPackage.id === item.id ? 'white' : 'primary.main' }}
          onClick={() => handleClick(item)}
        >
          {selectedPackage.id === item.id ? 'Batal' : 'Pilih'}
        </Button>
      </Box>
    </Card>
  );
}
